import { actOpenSysBrowser, isInApp } from './appSDK'

export function getParameterByName (name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[[]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

// 提取字符串中的url
export function extractUrl (str) {
  const r = str.match(/(https?):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/)
  if (r) {
    return r[0]
  }
  return null
}

export function extractUrlOrOriginal (str) {
  return extractUrl(str) || str
}

/**
 * https://gist.github.com/andjosh/6764939
 * @param {*} to
 * @param {*} duration
 */
export function scrollTo ({
  el = document.scrollingElement || document.documentElement,
  to,
  duration = 200
}) {
  const start = el.scrollTop
  const change = to - start
  const startDate = Date.now()
  // t = current time
  // b = start value
  // c = change in value
  // d = duration
  function easeInOutQuad (t, b, c, d) {
    t /= d / 2
    if (t < 1) return c / 2 * t * t + b
    t--
    return -c / 2 * (t * (t - 2) - 1) + b
  }
  function animateScroll () {
    const currentDate = Date.now()
    const currentTime = currentDate - startDate
    el.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration))
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll)
    } else {
      el.scrollTop = to
    }
  }
  animateScroll()
}

/**
 * scrollIt.js
 * https://cloud.tencent.com/developer/article/1197256
 * @param {*} destination
 * @param {*} duration
 * @param {*} easing
 * @param {*} callback
 */
export function scrollIt (destination, duration = 200, easing = 'easeOutCubic', callback) {
  const easings = {
    linear (t) {
      return t
    },
    easeOutCubic (t) {
      return --t * t * t + 1
    }
  }

  const start = window.pageYOffset
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime()

  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight
  const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset)

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll)
    if (callback) {
      callback()
    }
    return
  }

  function scroll () {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime()
    const time = Math.min(1, ((now - startTime) / duration))
    const timeFunction = easings[easing](time)
    window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start))
    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback()
      }
      return
    } else if (time >= 1) {
      window.scroll(0, destination)
      callback()
      return
    }

    requestAnimationFrame(scroll)
  }

  scroll()
}

export function scrollToEl (selectors, offset = 0) {
  const el = document.querySelector(selectors)
  if (el && el.closest('.dialog-conente-scroll')) {
    const parent = el.closest('.dialog-conente-scroll')
    const y = parent.scrollTop + el.getBoundingClientRect().top
    parent.scrollTo(0, y + offset - parent.getBoundingClientRect().top)
  } else if (el) {
    let y = window.pageYOffset + el.getBoundingClientRect().top
    if (document.querySelector('.appBarNav')) {
      y -= document.querySelector('.appBarNav').getBoundingClientRect().height
    }
    window.scrollTo(0, y + offset)
  }
}

export function sleep (s = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, s)
  })
}

export function getAppDownloadUrl () {
  const u = navigator.userAgent
  const isMagicbuy = location.origin.indexOf('magicbuy') > -1
  if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
    if (isMagicbuy) {
      return 'https://apps.apple.com/tw/app/%E8%B2%B7%E5%8D%B3%E5%8F%AF/id6480051573'
    }
    return 'https://apps.apple.com/tw/app/%E5%B7%A7%E5%B7%A7%E9%83%8E/id1500157983'
    // return 'https://itunes.apple.com/tw/app/%E5%B9%AB%E5%B9%AB%E5%AF%B6/id1451308787?mt=8'
  }
  if (isMagicbuy) {
    return 'https://play.google.com/store/apps/details?id=com.intl.magicbuy&pli=1'
  }
  // return 'https://static.kkren.com.tw/apk/kkren1.0.9.apk'
  return 'https://play.google.com/store/apps/details?id=com.jyb.warehouseclient'
}

export function copyText (text) {
  console.log('copyText', text)
  // const input = document.createElement('textarea')
  // input.addEventListener('focusin', e => e.stopPropagation())
  // document.body.appendChild(input)
  // input.setAttribute('value', text)
  // input.select()
  // if (document.execCommand('copy')) {
  //   document.execCommand('copy')
  // }
  // document.body.removeChild(input)

  const el = document.createElement('textarea')
  el.addEventListener('focusin', e => e.stopPropagation())
  el.value = text
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

export function toUnicodeFun (data) {
  let str = ''
  for (let i = 0; i < data.length; i++) {
    str += '\\u' + data.charCodeAt(i).toString(16)
  }
  return str
}

/**
 * 函数防抖 (只执行最后一次点击)
 */
export const Debounce = (func, delay = 1000, immediate = false) => {
  let timer = null
  // 不能用箭头函数
  return function () {
    // 在时间内重复调用的时候需要清空之前的定时任务
    if (timer) {
      clearTimeout(timer)
    }
    // 适用于首次需要立刻执行的
    if (immediate && !timer) {
      func.apply(this, arguments)
    }
    timer = setTimeout(() => {
      func.apply(this, arguments)
    }, delay)
  }
}

/*
 * 函数节流
 */
export const Throttle = (fn, t) => {
  let last
  let timer
  const interval = t || 500

  return function () {
    const args = arguments
    const now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        last = now
        fn.apply(this, args)
      }, interval)
    } else {
      last = now
      fn.apply(this, args)
    }
  }
}

export function setTitle (t) {
  document.title = t
  const i = document.createElement('iframe')
  i.src = '//m.baidu.com/favicon.ico'
  i.style.display = 'none'
  i.onload = function () {
    setTimeout(function () {
      i.remove()
    }, 9)
  }
  document.body.appendChild(i)
}

export function isPC () {
  const userAgentInfo = navigator.userAgent
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod', 'Macintosh']
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

export function hasRain (v) {
  return (v >= 8 && v <= 23) || (v >= 29 && v <= 41)
}

export function hexToRgbA (hex, opacity = 1) {
  let c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('')
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = '0x' + c.join('')
    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + `,${opacity})`
  }
  return hex
  // throw new Error('Bad Hex')
}

export function openGoods ({ itemid, traPlatform }) {
  const url = `https://item.taobao.com/item.htm?id=${itemid}`
  if (traPlatform === '1688') { //  1688
    return `https://detail.1688.com/offer/${itemid}.html`
  }
  actOpenSysBrowser(url)
}

// 打开 1688 商品详情：iOS 走 Universal Link、安卓走 intent，二者都自带「未安装则回落网页」；
// 裸 wireless1688:// scheme 在 iOS 及部分安卓浏览器唤不起，所以不用它
export function open1688Offer (offerId) {
  const h5 = `https://m.1688.com/offer/${offerId}.html`
  const ua = navigator.userAgent
  let target = h5
  if (/iPhone|iPad|iPod|Macintosh/.test(ua)) {
    target = `https://search.1688.com/redirect/m.1688.com/offer/${offerId}.html`
  } else if (/Android/.test(ua)) {
    // target = `intent://m.1688.com/offer/${offerId}.html#Intent;scheme=wireless1688;package=com.alibaba.wireless;S.browser_fallback_url=${encodeURIComponent(h5)};end;`
  }
  if (isInApp()) {
    actOpenSysBrowser(target)
  } else if (target === h5) {
    window.open(target)
  } else {
    window.location.href = target
  }
}

// 打开 1688 旺旺联系卖家：对齐官方手机商品详情的客服入口（chat-universal-page），传 offerId 可带商品卡
export function open1688Aliww (sellerLoginId, offerId) {
  let url = `https://air.1688.com/app/mobile-group/chat-universal-page/pages/index/index.html?appkey=923fa8de98cfcdc5915c7e6f5bac44ff&bizType=11152&targetType=8&targetId=${encodeURIComponent(sellerLoginId)}`
  if (offerId) url += `&itemId=${offerId}`
  actOpenSysBrowser(url)
}

export function readFile (fileRes) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsArrayBuffer(fileRes)
    reader.onload = () => {
      resolve(reader.result)
    }
  })
}

export function loadScript (src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    // script.id = 'vConsoleLog'
    script.type = 'text/javascript'
    script.src = src
    document.body.appendChild(script)

    script.onload = () => {
      setTimeout(() => {
        resolve()
      })
    }
  })
}

export function isOldVer (currVer, targetVer) {
  const targetVerSplit = targetVer.split('.')
  const currVerSplit = currVer.split('.')
  for (let i = 0; i < targetVerSplit.length; i++) {
    const c = Number(currVerSplit[i] || 0)
    const t = Number(targetVerSplit[i] || 0)
    if (t < c) {
      return false
    }
    if (t > c) {
      return true // 旧版
    }
  }
  return false
}

export function decodeHtml (str) {
  let s = ''
  if (str.length === 0) return ''
  s = str.replace(/&amp;/g, '&')
  s = s.replace(/&lt;/g, '<')
  s = s.replace(/&gt;/g, '>')
  s = s.replace(/&nbsp;/g, ' ')
  s = s.replace(/&quot;/g, '"')
  return s
}

// export function genRandStr () {
//   const randomBytes = new Uint8Array(16)
//   window.crypto.getRandomValues(randomBytes)
//   const base64String = btoa(String.fromCharCode.apply(null, randomBytes))
//   const encodedString = base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
//   return encodedString
// }

export function genRandStr (length = 16) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

export function isTwCellphone (val) {
  return /^09\d{8}$/.test(val.trim())
}

export function isTwLandline (val) {
  return /^((0(2|4)\d{8})|(0[3-8]\d{7}))$/.test(val.trim().replace('-', ''))
}

// 字符的显示宽度，中文为1，英文为0.5
export function getViewWidth (str) {
  let len = 0
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i)
    // 单字节为0.5
    if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
      len += 0.5
    } else {
      // 其他的为 1
      len += 1
    }
  }
  return len
}

export function jsonp (url, callbackName = 'callback') {
  return new Promise((resolve, reject) => {
    // 创建一个全局唯一的回调函数名称
    const uniqueCallbackName = 'jsonp_callback_' + Math.round(100000 * Math.random())

    // 在window对象上定义回调函数
    window[uniqueCallbackName] = function (data) {
      resolve(data) // 当JSONP请求成功时，使用Promise的resolve方法返回数据
      delete window[uniqueCallbackName] // 删除全局回调函数
      script.remove() // 删除script标签
    }

    // 创建script标签并设置其src属性
    const script = document.createElement('script')
    script.src = `${url}${url.indexOf('?') > -1 ? '&' : '?'}${callbackName}=${uniqueCallbackName}`
    script.onerror = function () {
      reject(new Error(`JSONP request to ${url} failed`)) // 请求失败时，使用Promise的reject方法返回错误
      delete window[uniqueCallbackName] // 删除全局回调函数
      script.remove() // 删除script标签
    }

    // 将script标签添加到文档中触发请求
    document.body.appendChild(script)
  })
}
